<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code" clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Farm" prop="farmName">
                    <el-input v-model="queryCondition.farmName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Farm Group" prop="farmGroup">
                    <el-input v-model="queryCondition.farmGroup" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="商品名" prop="productName">
                      <el-input v-model="queryCondition.productName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="用途分类" prop="useClass">
                      <el-select v-model="queryCondition.useClass" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in useClassList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="有效成分" prop="effectiveComponentsList">
                      <el-select v-model="queryCondition.effectiveComponentsList" filterable clearable multiple collapse-tags style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="top" v-if="item.name.length>20">
                            <span style="display:inline-block;width:300px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.name }}</span>
                          </el-tooltip>
                          <span style="display:inline-block;width:300px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;" v-else>{{ item.name }}</span>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="药品状态" prop="medicineUseStatus">
                      <ic-select table="TT_RMC_PRODUCE_MEDICINE" filterable field="MEDICINE_USE_STATUS" clearable v-model="queryCondition.medicineUseStatus" style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="审批状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable placeholder="请选择" style="width:100%" filterable class="multiple_sel">
                        <el-option :key="index" v-for="(item,index) in statusOption" :label="item.chineseValue" :value="item.code"></el-option>
                      </el-select>
                      <!-- <ic-select table="TT_RMC_PRODUCE_MEDICINE" filterable field="STATUS" clearable v-model="queryCondition.status"  style="width:100%"></ic-select> -->
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button v-acl="RMC_PROD_MEDICINE_ADD" class="btn" type="primary" @click="addList">新增</el-button>
        <el-button v-acl="RMC_PROD_MEDICINE_DELETE" class="btn" type="danger" @click="onDel">删除</el-button>
        <el-button v-acl="RMC_PROD_MEDICINE_SUBMIT" class="btn" type="primary" @click="submit">提交</el-button>
        <el-button v-acl="RMC_PROD_MEDICINE_CONFIRM" class="btn" type="primary" @click="isUpdate">确认无更新</el-button>
        <!-- <el-button   class="btn" type="primary" @click="approve">批准</el-button>
        <el-button   class="btn" type="primary" @click="sendBack">退回</el-button> -->
        <el-dropdown v-acl="RMC_PROD_MEDICINE_REPORT" split-button type="primary" @click="handleClick" placement="bottom" style="margin-right: 10px;">
          报表
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button v-acl="RMC_PROD_MEDICINE_REPORT" size="mini" class="dropdownItemBtn" type="primary" @click="exportMedicine">药品清单</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button v-acl="RMC_PROD_MEDICINE_REPORT_QUR" size="mini" class="dropdownItemBtn" type="primary" @click="exportSnapshot">药品清单(季度)</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-acl="RMC_PROD_MEDICINE_IMPORT" class="btn" type="primary" @click="importData">批量导入</el-button>
        <el-button v-acl="RMC_PROD_MEDICINE_HISTORY" class="btn" type="primary" @click="openHistory">查看历史</el-button>
        <el-button v-acl="RMC_PROD_MEDICINE_CHANGE_LOG" class="btn" type="primary" @click="updateLog">更新日志</el-button>
      </el-row>
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" fixed="left" />
        <ux-table-column align="center" title="Category3" fixed="left" field="category3Name" width="120" />
        <ux-table-column align="center" title="Sponsor" fixed="left" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="Farm" fixed="left" min-width="120" field="farmName"></ux-table-column>
        <ux-table-column align="center" title="Farm Group" fixed="left" min-width="120" field="farmGroup"></ux-table-column>
        <ux-table-column align="center" title="商品名" fixed="left" min-width="140" field="productName">
          <template v-slot="scope">
            <el-button type="text" @click="goDetail(scope.row)">{{scope.row.productName}}</el-button>
          </template>
        </ux-table-column>
        <ux-table-column align="center" title="有效成分" fixed="left" min-width="120" field="effectiveComponents"></ux-table-column>
        <ux-table-column align="center" title="用途分类" min-width="100" field="useClass"></ux-table-column>
        <ux-table-column align="center" title="作物名称" min-width="120" field="cultiVarName"></ux-table-column>
        <ux-table-column align="center" title="含量" min-width="120" field="contents"></ux-table-column>
        <ux-table-column align="center" title="安全间隔期/天" min-width="120" field="safetyDay"></ux-table-column>
        <ux-table-column align="center" title="生产厂家" min-width="120" field="producer"></ux-table-column>
        <ux-table-column align="center" title="剂型" min-width="120" field="dosageForm"></ux-table-column>
        <ux-table-column align="center" title="使用方法" min-width="120" field="usage"></ux-table-column>
        <ux-table-column align="center" title="指导用量" min-width="120" field="guideUsage"></ux-table-column>
        <ux-table-column align="center" title="最多使用次数/季" min-width="120" field="maximum"></ux-table-column>
        <ux-table-column align="center" title="农药登记证号" min-width="120" field="pesticideNumber"></ux-table-column>
        <ux-table-column align="center" title="GB 2763" min-width="120" field="finiteQuantity"></ux-table-column>
        <ux-table-column align="center" title="其他标准" min-width="120" field="otherStandard"></ux-table-column>
        <ux-table-column align="center" title="修改原因" min-width="120" field="modifyReason"></ux-table-column>
        <ux-table-column align="center" title="药品在用状态" min-width="120" field="medicineUseStatusI18n"></ux-table-column>
        <ux-table-column align="center" title="状态" min-width="120" field="statusI18n"></ux-table-column>
        <ux-table-column align="center" title="提交人" min-width="120" field="submitUser"></ux-table-column>
        <ux-table-column align="center" title="提交日期" min-width="120" field="submitDate"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">更新日志 </p>
          </div>
        </div>
        <updateDialog v-if="dialogVisible" @close="handleClose"></updateDialog>
      </el-dialog>

      <el-dialog title="" :visible.sync="exportDialog" width="30%" :before-close="closeExportDialog">
        <div slot="title" class="header-title">
          <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
            <p class="line"></p>
            <p class="info_title">选择季度</p>
          </div>
        </div>
        <exportDialog v-if="exportDialog" @closeExport="closeExportDialog" :exportTitle="exportTitle"></exportDialog>
      </el-dialog>

      <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
        <el-row style="margin-bottom:10px">
          <el-upload ref="batchUpload" :headers="header" :action="uploadListsUrl" :on-success="uploadListsSuccess" :on-change="handleChange" :before-upload="beforeListsUpload" :file-list="importFileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
            <el-button size="small" type="primary">选取文件</el-button>
          </el-upload>
          <!-- <el-link type="button" target="_blank" href="static/template/qspi/RMC_Protein_FeedFactory_Tpl.xlsx" download="RMC_Protein_FeedFactory_Tpl.xlsx"> -->
          <el-button class="btn" type="primary" size="small" style="height:100%" @click="downloadImportTem">导入模板下载</el-button>
          <!-- </el-link> -->
        </el-row>
        <el-form :model="uploadForm" ref="uploadForm">
          <el-form-item>
            <el-input v-model="uploadForm.fileName" readonly></el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <h4>说明:</h4>
          <ul>
            <li>1.请点击模板下载,按照模板填写后再上传</li>
            <li>2.模板中红色字段为必填项,请务必正确填写</li>
            <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
            <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
            <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
          </ul>
        </el-row>
        <el-row type="flex" justify="center">
          <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
          <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
        </el-row>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import ratingTask from "@/api/AAA/ratingTask.js";
import apiService from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import updateDialog from '@/components/page/RMC/Produce/rmcProDrugList/updateDialog'
import proteinDrug from "@/api/rmcProtein/drug";
import prodMedicine from "@/api/rmcProduce/prodMedicine";
import exportDialog from '@/components/page/RMC/Protein/rmcDrugList/dialog/exportDialog'
import { fileService } from "@/api/common/file-utils";
import moment from "moment";

export default {
  name: '',
  components: {
    updateDialog,
    IcSelect,
    exportDialog
    // detailDialog
  },
  data() {
    return {
      dialogBatchUploadVisible: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadForm: {
        fileName: "",
      },
      importFileList: [],
      exportTitle: "",
      exportDialog: false,
      identity: localStorage.getItem('ms_emplFlag'),
      dialogVisible: false,
      allDate: [],
      statusOption: [],
      effectiveComponentsList: [],
      useClassList: [],
      multipleSelection: [],
      category3List: [],
      statusList: [],
      queryCondition: {
        category3Code: "",
        sponsorName: "",
        farmGroup: "",
        productName: "",
        useClass: "",
        farm: "",
        effectiveComponentsList: [],
        status: "",
        medicineUseStatus: "INUSE",
        pageNum: 1,
        pageSize: 15,
        status: "",
      },
      isShow: false,
      showDetailDialog: false,
      tableData: [],
      formData: null,
      totalCount: "",
      statusView: "",
      ms_roles: JSON.parse(localStorage.getItem('ms_roles'))

    }
  },
  computed: {
    uploadListsUrl() {
      return process.env.VUE_APP_SERVER_BASE_URL + `rmc/produce/medicine/importExcelForProduceMedicine`;
    },
  },
  created() {
    let queryData = this.$store.state.asl.skipQuery
    let qspiInfo = JSON.parse(sessionStorage.getItem('qspiInfo'))
    if (qspiInfo) {

      if (qspiInfo.SPONSOR_NAME) {
        this.$set(this.queryCondition, 'sponsorName', qspiInfo.SPONSOR_NAME)
      }
      if (qspiInfo.AUDIT_STATUS) {
        this.$set(this.queryCondition, 'status', qspiInfo.AUDIT_STATUS)
      }
    }
    // if(queryData.sponsorName){
    //   this.$set(this.queryCondition,'sponsorName',queryData.sponsorName)
    // }
    // if(queryData.category3Code){
    //   this.$set(this.queryCondition,'category3Code',queryData.category3Code)
    // }
    if (queryData.farmGroup) {
      this.$set(this.queryCondition, 'medicineUseStatus', "")
      this.$set(this.queryCondition, 'farmGroup', queryData.farmGroup)
    }
    console.log("sssssssssssss", queryData)
    this.getStatusList()
    this.getSelector()
    this.getdCategory3()
    this.queryData();
  },
  destroyed() {
    this.$store.dispatch('saveQueryData', {})
    sessionStorage.setItem('qspiInfo', null)
  },
  methods: {
    getStatusList() {
      prodMedicine.getStatusList({
        "TT_RMC_PRODUCE_MEDICINE:STATUS": "TT_RMC_PRODUCE_MEDICINE:STATUS",
      }).then((res) => {
        if (this.ms_roles.indexOf('QSPI_RMC_PRODUCE_CQS') !== -1) {
          this.statusOption = res["TT_RMC_PRODUCE_MEDICINE:STATUS"].filter(ele => {
            return ele.code != "DRAFT"
          })
        } else {
          this.statusOption = res["TT_RMC_PRODUCE_MEDICINE:STATUS"];
        }
      })
    },
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1
      }
      prodMedicine.getMedicineList(this.queryCondition).then((res) => {
        this.tableData = res.resultData
        this.totalCount = res.totalCount
      })
    },
    openHistory() {
      let drugId = []
      this.multipleSelection.forEach((v) => {
        drugId.push(v.ttRmcProduceMedicineId)
      })
      sessionStorage.setItem('drugId', JSON.stringify(drugId))
      this.$router.push({
        path: "/proDrugHistory",
        query: {

        }
      })

    },
    goDetail(row) {
      this.$router.push({
        path: "/rmcProdMedicine/detail",
        query: {
          id: row.ttRmcProduceMedicineId
        }
      })
    },
    closeExportDialog() {
      this.exportDialog = false
    },
    onReset() {
      this.queryCondition = {
        category3Code: "",
        sponsorName: "",
        farmGroup: "",
        productName: "",
        farmName: "",
        useClass: "",
        effectiveComponents: [],
        status: "",
        medicineUseStatus: "",
        pageNum: 1,
        pageSize: 15,
        status: "",
      }
      this.queryData();
    },
    exportMedicine() {
      let ids = []
      this.multipleSelection.forEach((v) => {
        ids.push(v.ttRmcProduceMedicineId)
      })
      this.queryCondition.produceMedicineIds = ids
      prodMedicine.exportMedicine(this.queryCondition).then((res) => {
        fileService.respToFile(res, 'Produce_药品清单.xlsx');
      })
    },
    exportSnapshot() {
      this.exportTitle = 'Produce'
      this.exportDialog = true
    },
    addList() {
      this.$router.push({
        path: "/rmcProdMedicine/detail",
        query: {

        }
      })
    },
    getdCategory3() {
      proteinDrug.getdCategory3().then((res) => {
        this.category3List = res.data.filter((v) => {
          return v.cascadeKey == 'produce'
        })
      })
    },
    downloadImportTem() {
      prodMedicine.importExcelForProduceMedicineTemp().then((res) => {
        fileService.respToFile(res, 'RMC_Produce_药品清单导入模板.xlsx');
      })
    },
    pageSizeChange(val) {
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val) {
      this.queryCondition.pageNum = val
      this.queryData()
    },
    isUpdate() {
      // let strMsg=''
      // console.log("当前年月",moment().format("YYYY")+'/'+moment().format("MM")  )
      // if(moment().format('MM')==1||moment().format('MM')==2||moment().format('MM')==3){
      //   strMsg='评价期'+moment().add(-1, 'y').format("YYYY")+'Q4'+"已确认无更新"
      // }else{
      //   strMsg='评价期'+moment().format("YYYY")+' Q'+moment().add(-1, 'Q').quarter()+"已确认无更新"
      // }
      // console.log("11111111",strMsg)
      // let params={
      //   produceMedicineIds:[]
      // }
      // this.multipleSelection.forEach((v)=>{
      //   params.produceMedicineIds.push(v.ttRmcProduceMedicineId)
      // })
      prodMedicine.approveAndNotUpdate().then((res) => {
        if (res.code == 200) {
          this.$message.success(res.data)
          this.queryData()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let isCreate = this.multipleSelection.some((v) => {
          return v.status != 'DRAFT'
        })
        if (isCreate) {
          this.$message.error("仅可删除草稿状态的清单")
        } else {
          this.$confirm('请确认是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            customClass: 'colorBtn',
            cancelButtonClass: 'btn_custom_cancel',
            type: 'warning'
          }).then(() => {
            let params = {
              produceMedicineIds: []
            }
            this.multipleSelection.forEach((v) => {
              params.produceMedicineIds.push(v.ttRmcProduceMedicineId)
            })
            prodMedicine.deleteMedicine(params).then((res) => {
              if (res.code == 200) {
                this.$message.success('删除成功')
                this.multipleSelection = []
                this.queryData()
              } else {
                this.$message.error(res.msg)
              }
            })
          })
        }
      }

    },
    approve() {
      console.log("批准")
    },
    sendBack() {
      console.log("退回")
    },
    importData() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.importFileList = []
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.importFileList = []
    },
    beforeListsUpload(file) {
      console.log('beforeUpload', file);
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.importFileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    uploadListsSuccess(resp) {
      console.log('resp', resp);
      var data = resp.data.split(',')
      console.log('data', data);
      var successNum = Number(data[0].split('{')[1].split(':')[1])
      console.log('successNum', successNum);
      var errorNum = Number(data[1].split('}')[0].split(':')[1])
      console.log('errorNum', errorNum);
      var total = Number(successNum + errorNum)
      this.dialogBatchUploadVisible = false
      this.importFileList = []
      this.uploadForm.fileName = ''
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据' + successNum + '条');
        this.queryData();
      } else {
        console.log('resp.meta.msg', resp.meta.msg);
        var totalText = '导入文件数据共 ' + total + ' 条'
        var successText = '满足导入条件: ' + successNum + ' 条'
        var errorText = '不满足导入条件: ' + errorNum + ' 条'
        var sumText = '如果存在导入失败的数据,请导出失败原因,修改后再重新上传'
        const wordText = [totalText, successText, errorText, sumText]
        var newArr = []
        const h = this.$createElement;
        for (const i in wordText) {
          newArr.push(h('p', null, wordText[i]))
        }
        this.$confirm('导入结果', {
          title: '导入结果',
          message: h('div', null, newArr),
          showCancelButton: true,
          confirmButtonText: '导出失败原因',
          confirmButtonClass: "confirmButtonClass",
          cancelButtonClass: "cancelButtonClass",
          cancelButtonText: '取消',
          customClass: "uploadBtn",
          type: 'warning'
        }).then(() => {
          let str = new Blob([resp.meta.msg], { type: 'text/plain;charset=utf-8' })
          saveAs(str, '导入失败原因报表.txt')
        }).catch(() => {
          this.$message.info('已取消导出失败原因')
        })
      }
    },
    submit() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请先选择数据后再操作')
      } else {
        let params = {
          produceMedicineIds: []
        }
        this.multipleSelection.forEach((v) => {
          params.produceMedicineIds.push(v.ttRmcProduceMedicineId)
        })
        prodMedicine.submitMedicine(params).then((res) => {
          if (res.code == 200) {
            this.$message.success('提交成功')
            this.multipleSelection = []
            this.queryData()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    updateLog() {
      this.dialogVisible = true
    },
    selectionChange(val) {
      this.multipleSelection = val
    },
    handleClose() {
      this.dialogVisible = false
      this.queryData()
    },
    getSelector() {
      prodMedicine.getSelector().then((res) => {
        res.data.effectiveComponentsList.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.effectiveComponentsList.push(obj)
        })
        let set = new Set(res.data.useClassList);
        set.forEach((v) => {
          let obj = {}
          obj.name = v
          obj.code = v
          this.useClassList.push(obj)
        })
        console.log("获取的下拉框列表=====", res.data)
      })
    }

  },
  extends: commonFunction
}
</script>
<style scoped >
.searchForm /deep/ .el-select__tags-text {
  display: inline-block;
  max-width: 85px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.searchForm /deep/ .el-tag__close.el-icon-close {
  top: -5px;
}
.searchForm /deep/ .el-select__tags{
  flex-wrap: nowrap!important;
}
.searchForm /deep/ .el-tag.el-tag--info{
  max-width: 110px;
}
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
.line {
  width: 3px;
  height: 16px;
  margin: 7px 0;
  background-color: #f8ab01;
}
.info_title {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
  margin-left: 5px;
}
</style>
